import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, isEmpty } from "../../../Schema";
import { yesNoBooleanOptions } from "../../common";

export const isHazardous: FieldSchema = {
  grid: {
    displayed: true,
    order: 75,
    ignoredForSearch: true,
  },
  name: "isHazardous",
  data: {
    variant: DataVariants.ENUM,
    options: yesNoBooleanOptions,
    assignedValue: {
      getter: ({ isHazardous, isBookable }) =>
        !isBookable ? EMPTY_VALUE : isEmpty(isHazardous) ? false : isHazardous,
      fields: ["isBookable"],
    },
  },
  dataTransform: {
    // A non-bookable equipment has no booking behaviour to record, so the stored value
    // is cleared rather than left behind to contradict isBookable.
    toDb: {
      getter: ({ isBookable, isHazardous }) =>
        isBookable === false ? EMPTY_VALUE : isHazardous,
      fields: ["isBookable", "isHazardous"],
    },
  },
  display: {
    displayed: true,
  },
  validation: {
    required: {
      getter: ({ isBookable }) => isBookable === true,
      fields: ["isBookable"],
    },
  },
  form: {
    label: "Hazardous approval",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ isBookable }) => isBookable !== true,
      fields: ["isBookable"],
    },
    helperText: "Allow user to request assistance during the booking",
  },
};
